import type { FileRejection } from 'react-dropzone';

import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import { fData } from 'src/utils/format-number';

import { varAlpha } from 'src/theme/styles';

import { fileData } from '../../file-thumbnail';
import { useTranslation } from 'react-i18next';

// ----------------------------------------------------------------------

type Props = {
  files: FileRejection[];
  maxFileSize?: number;
};

export function RejectionFiles({ files, maxFileSize }: Props) {
  if (!files.length) {
    return null;
  }
  const { t } = useTranslation('common');

  return (
    <Paper
      variant="outlined"
      sx={{
        py: 1,
        px: 2,
        mt: 3,
        textAlign: 'left',
        borderStyle: 'dashed',
        borderColor: 'error.main',
        bgcolor: (theme) => varAlpha(theme.vars.palette.error.mainChannel, 0.08),
      }}
    >
      {files.map(({ file, errors }) => {
        const { path, size } = fileData(file);

        return (
          <Box key={path} sx={{ my: 1 }}>
            <Typography variant="subtitle2" noWrap>
              {path} - {size ? fData(size) : ''}
            </Typography>

            {errors.map((error) => (
              <Box key={error.code} component="span" sx={{ typography: 'caption' }}>
                - {t(`common:fileRejections.${error.code}`,( maxFileSize ? { maxSize: Math.round(maxFileSize / (1024 * 1024)) } : {}))}
              </Box>
            ))}
          </Box>
        );
      })}
    </Paper>
  );
}
